var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 18,
    viewBox: "0 0 98 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9858 1.84725C27.4764 0.343345 26.54 0 26.0945 0H22.8398V17.312H25.4447V2.62474L26.1811 4.69758L30.8985 17.312H34.0936L38.7869 4.69758L39.5488 2.74392V17.312H42.1537V0H38.8891C38.4493 0 37.6051 0.307875 37.0816 1.62167L33.9475 10.4366L32.4975 15.0362L31.0475 10.4366L27.9929 1.84158L27.9858 1.84867V1.84725Z",
    fill: "#0A0A0A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2963 5.17725C46.8614 5.17725 44.0664 7.60762 44.0664 11.3759C44.0664 15.1442 46.86 17.5746 50.2963 17.5746C53.7326 17.5746 56.5503 15.1442 56.5503 11.3759C56.5503 7.60762 53.7567 5.17725 50.2963 5.17725V5.17725ZM50.2963 15.269C47.7992 15.269 46.6131 14.029 46.6131 11.3759C46.6131 8.72278 47.7992 7.48277 50.2963 7.48277C52.7933 7.48277 54.0035 8.72278 54.0035 11.3759C54.0035 14.029 52.8174 15.269 50.2963 15.269Z",
    fill: "#0A0A0A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1761 5.17725C62.855 5.17725 61.5937 6.39172 61.0276 8.29714V5.42411H58.5078V17.3107H61.0276V11.715C61.0276 8.96539 62.3116 7.48135 64.312 7.48135C65.9167 7.48135 66.9056 8.39788 66.9056 10.1799V17.3135H69.4253V10.0068C69.4253 6.85992 67.9682 5.17725 65.1761 5.17725V5.17725Z",
    fill: "#0A0A0A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.7324 1.74637C74.7565 2.82464 74.1436 3.43613 73.0157 3.43613C71.8877 3.43613 71.3231 2.82322 71.2975 1.74637C71.2734 0.69363 71.9119 0.130374 73.0157 0.130374C74.0968 0.128955 74.7083 0.692211 74.7324 1.74637V1.74637Z",
    fill: "#0A0A0A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2452 5.39404H71.7227V17.3118H74.2452V5.39404Z",
    fill: "#0A0A0A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.6472 7.70565V5.4583H81.0449V1.82764H78.528V5.4583H76.0352V7.70565H78.528V14.0277C78.528 16.0041 79.8361 17.3122 81.8096 17.3122H84.2783V15.0649H81.0449V7.70565H84.6472Z",
    fill: "#0A0A0A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.3937 5.17725C87.9844 5.17725 85.5625 7.68139 85.5625 11.4C85.5625 15.1186 87.9092 17.5731 91.5171 17.5731C93.939 17.5731 96.314 15.8053 96.6829 13.6559H94.4568C93.9134 15.0945 93.197 15.5145 91.5412 15.5145C89.318 15.5145 88.3036 14.5724 88.1319 12.1676H96.9766C97.0007 11.6965 97.0007 11.4979 97.0007 11.1262C97.0021 7.48276 94.7037 5.17725 91.3923 5.17725H91.3937ZM88.1589 10.309C88.3816 8.15101 89.4429 7.1607 91.4206 7.1607C93.3984 7.1607 94.3859 8.029 94.4838 10.309H88.1589Z",
    fill: "#0A0A0A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5582 13.2457C19.0165 12.8981 19.3882 12.2185 19.3882 11.7262V5.58574C19.3882 5.09342 19.0151 4.41383 18.5582 4.06623L13.2946 0H8.01953L17.453 7.13789C17.9113 7.48549 18.283 8.16508 18.283 8.6574C18.283 9.14972 17.9099 9.82931 17.453 10.1769L8.01953 17.312H13.2946L18.5582 13.2443V13.2457Z",
    fill: "#3C37FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3954 13.3876C10.8537 13.04 11.2254 12.3604 11.2254 11.8681V5.44386C11.2254 4.95154 10.8523 4.27195 10.3954 3.92435L5.27503 0H0L9.43206 7.13789C9.89032 7.48549 10.262 8.16508 10.262 8.6574C10.262 9.14972 9.8889 9.82931 9.43206 10.1769L0 17.312H5.27503L10.3968 13.3862L10.3954 13.3876Z",
    fill: "#3C37FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.59351f6f41c5ae9588487eaf6b7a13a5.svg";
export { ForwardRef as ReactComponent };